export const LOCALSTORAGE_KEYS = {
  authToken: "auth._token.local"
};
export const COOKIE_KEYS = {
  authToken: "auth._token.local",
  savedOrganization: "organization.id"
};
export const monthNamesShort = [
  "\u044F\u043D\u0432",
  "\u0444\u0435\u0432",
  "\u043C\u0430\u0440",
  "\u0430\u043F\u0440",
  "\u043C\u0430\u0439",
  "\u0438\u044E\u043D",
  "\u0438\u044E\u043B",
  "\u0430\u0432\u0433",
  "\u0441\u0435\u043D",
  "\u043E\u043A\u0442",
  "\u043D\u043E\u044F",
  "\u0434\u0435\u043A"
];
export const monthNames = [
  "\u042F\u043D\u0432\u0430\u0440\u044C",
  "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
  "\u041C\u0430\u0440\u0442",
  "\u0410\u043F\u0440\u0435\u043B\u044C",
  "\u041C\u0430\u0439",
  "\u0418\u044E\u043D\u044C",
  "\u0418\u044E\u043B\u044C",
  "\u0410\u0432\u0433\u0443\u0441\u0442",
  "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
  "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
  "\u041D\u043E\u044F\u0431\u0440\u044C",
  "\u0414\u0435\u043A\u0430\u0431\u0440\u044C"
];
export const weekDayNames = [
  "\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
  "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
  "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
  "\u0421\u0440\u0435\u0434\u0430",
  "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
  "\u041F\u044F\u0442\u043D\u0438\u0446\u0430",
  "\u0421\u0443\u0431\u0431\u043E\u0442\u0430"
];
export const DEFAULT_DATE_FORMAT = "DD.MM.YYYY HH:mm";
